import React, { useEffect, useState } from "react";
import { Loader2, Users } from "lucide-react";
import { getWebinarsAPI, getWebinarRegistrationsAPI } from "../services/apicollection";
import DataTable from "../Components/Table";

const WebinarRegistrationsPage = () => {
  const [webinars, setWebinars] = useState([]);
  const [selectedWebinarId, setSelectedWebinarId] = useState("");
  const [registrations, setRegistrations] = useState([]);
  const [loadingWebinars, setLoadingWebinars] = useState(false);
  const [loadingRegistrations, setLoadingRegistrations] = useState(false);
  const [error, setError] = useState(null);
  const controller = new AbortController();
  useEffect(() => {
    const loadWebinars = async () => {
      setLoadingWebinars(true);
      setError(null);
      try {
        const res = await getWebinarsAPI({ signal: controller.signal });
        const payload = res.data;
        if (res.status && payload && Array.isArray(payload.webinars)) {
          setWebinars(payload.webinars);
        } else {
          setWebinars([]);
        }
      } catch (err) {
        setError(err.response?.data?.message || "Failed to load webinars");
        setWebinars([]);
      } finally {
        setLoadingWebinars(false);
      }
    };
    loadWebinars();
    return () => {
      controller.abort();
    };
  }, []);

  useEffect(() => {
    if (!selectedWebinarId) {
      setRegistrations([]);
      return;
    }

    const loadRegistrations = async () => {
      setLoadingRegistrations(true);
      setError(null);
      try {
        const res = await getWebinarRegistrationsAPI(selectedWebinarId);
        if (res.status && Array.isArray(res.data)) {
          const rows = res.data.map((r) => ({
            name: r.name,
            email: r.email,
            phone: r.phone,
            profession: r.profession,
            registered_at: new Date(r.createdAt).toLocaleString("en-IN"),
          }));
          setRegistrations(rows);
        } else {
          setRegistrations([]);
        }
      } catch (err) {
        setError(
          err.response?.data?.message ||
            "Failed to load webinar registrations"
        );
        setRegistrations([]);
      } finally {
        setLoadingRegistrations(false);
      }
    };

    loadRegistrations();
  }, [selectedWebinarId]);

  return (
    <div className="space-y-4">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <h2 className="text-lg font-semibold text-slate-200">
          Events registrations
        </h2>
      </div>

      <section className="space-y-3">
        <div className="flex flex-wrap items-center gap-3">
          <label className="text-xs font-medium text-slate-400">
            Select Event To View Registrants
          </label>
          <select
            value={selectedWebinarId}
            onChange={(e) => setSelectedWebinarId(e.target.value)}
            className="min-w-[220px] bg-[#0d1220] text-slate-100 rounded-lg border border-[#1d3350] px-3 py-2 text-sm outline-none focus:border-slate-500 focus:ring-1 focus:ring-slate-500"
          >
            <option value="">
              {loadingWebinars ? "Loading Events..." : "Choose Events"}
            </option>
            {webinars.map((w) => (
              <option key={w._id} value={w._id}>
                {w.topic}
              </option>
            ))}
          </select>
        </div>

        {error && (
          <div className="rounded-lg border border-red-500/30 bg-red-500/10 px-4 py-3 text-xs text-red-400">
            {error}
          </div>
        )}

        {!selectedWebinarId ? (
          <div className="flex flex-col items-center justify-center rounded-lg border border-[#1d3350] bg-[#0f1c2e] py-12 text-center text-slate-500">
            <Users size={32} className="text-slate-300" />
            <p className="mt-2 text-sm">
              Select a Events to view registrants.
            </p>
          </div>
        ) : loadingRegistrations ? (
          <div className="flex items-center justify-center rounded-lg border border-[#1d3350] bg-[#0f1c2e] py-12">
            <Loader2 size={28} className="animate-spin text-slate-400" />
          </div>
        ) : registrations.length === 0 ? (
          <div className="flex flex-col items-center justify-center rounded-lg border border-[#1d3350] bg-[#0f1c2e] py-12 text-center text-slate-500">
            <Users size={32} className="text-slate-300" />
            <p className="mt-2 text-sm">
              No registrations for this webinar yet.
            </p>
          </div>
        ) : (
          <DataTable data={registrations} />
        )}
      </section>
    </div>
  );
};

export default WebinarRegistrationsPage;